import { render, staticRenderFns } from "./App.vue?vue&type=template&id=71576340&"
import script from "./App.vue?vue&type=script&lang=ts&"
export * from "./App.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('71576340')) {
      api.createRecord('71576340', component.options)
    } else {
      api.reload('71576340', component.options)
    }
    module.hot.accept("./App.vue?vue&type=template&id=71576340&", function () {
      api.rerender('71576340', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "landing/src/App.vue"
export default component.exports